export class ShowSoilUseCase {
  constructor(repository) {
    this.repository = repository
  }
  async execute() {
    const resp= await this.repository.show()
    return resp
  }
}
